import { ProductCatalogResponse } from '../../config';

export const adaptProductCatalog = (data: ProductCatalogResponse) => {
  return {
    category: data.category,
    id: data.id,
    name: data.name,
    slug: data.slug,
    total_count: data.total_count,
    product_list: data.product_list,
    filter_attributes: data.filter_attributes,
    sort_attributes: Object.entries(data.sort_attributes).map((item) => {
      return {
        label: item[1],
        value: item[0],
      };
    }),
    page_text: data.page_text,
  };
};
